<template>
  <div class="pb-3 order-grid-wrapper">
    <div>
      <div class="subheader-wrapper">
        <div class="d-flex align-items-center">
          <h5>{{OrderLineGroupName}}</h5>
          <div v-if="!gridIndex && !readOnly" class="btn btn-primary btn-sm ml-4" @click="launchSmartCatalogModal">SmartCatalog Search</div>
          <div v-if="!gridIndex && !readOnly" class="btn btn-primary btn-sm ml-4" @click="launchConfiguratorModal">Configurator</div>
        </div>
        <div v-if="!readOnly" class="icon-group">
          <i class="fa fa-plus"     @click="addNewRow"               aria-hidden="true"></i>
          <i class="fa fa-cubes"    @click="toggleCreateBundleModal"         aria-hidden="true"></i>
          <i v-if="gridIndex" class="fa fa-edit" @click="openEditBundleModal" aria-hidden="true"></i>
          <i v-if="gridIndex" class="fa fa-trash" @click="toggleDeleteBundle" aria-hidden="true"></i>
          <!-- <i class="fa fa-copy" @click="copyOrderLines" aria-hidden="true"></i> -->
        </div>
      </div>
      <hr>

    </div>
    
    <DxDataGrid
      :ref="refName"
      key-expr="LineNumber"
      :key="datagridUpdateKey"
      :data-source="dataSource"
      :show-row-lines="showRowLines"
      :show-column-lines="showColumnLines"
      :row-alternation-enabled="alternateRowEnabled"
      :allow-column-resizing="true"
      :column-resizing-mode="columnResizingMode" 
      width="100%"
      :column-min-width="25"
      :row-width="20"
      :show-borders="true"
      :column-auto-width="false"
      :filter-value="filterExpr"
      :on-cell-prepared="onCellPrepared"
      @editor-preparing="onEditorPreparing"
      @editing-start="onEditingStart"
      @row-updated="setCalculatedValues"
      :on-context-menu-preparing="addMenuItems"
      @init-new-row="initNewRow"
    >
      <DxPaging :enabled="false" />
      <DxSorting mode="none"/>
      <DxRowDragging
        v-if="!readOnly"
        :data="OrderLineGroupId"
        :on-add="onAdd"
        :allow-reordering="true"
        :on-reorder="onReorder"
        group="tasksGroup" 
      />
      <DxSelection
        v-if="multiSelect && !readOnly"
        select-all-mode="allPages"
        show-check-boxes-mode="always"
        mode="multiple"
      />
      
      <DxEditing
        v-if="!readOnly"
        :allow-updating="true"
        :allow-adding="false"
        :allow-editing="true"
        :on-add="onAdd"
        :select-text-on-edit-start="true"
        :allow-deleting="true"
        :useIcons="true"
        mode="cell"
      />
      <!-- <DxColumn :width="40" data-field="LineNumber"         caption="Line"   header-cell-template="title-header" cell-template="grid-cell" :allowEditing="false"/> -->
      <DxColumn :width="40" data-field="Quantity"   caption="Qty"    header-cell-template="title-header" cell-template="grid-cell"/>
      <!-- <DxColumn :width="40" data-field="MfgCode"        caption="MFI"    header-cell-template="title-header" cell-template="grid-cell"/>
      <DxColumn :width="60" data-field="PartNumber" caption="Part #" header-cell-template="title-header" cell-template="grid-cell"/> -->
      <DxColumn
        :min-width="65"
        :width="65"
        :allow-sorting="false"
        :allowEditing="true"
        data-field="MfgCode"
        caption="MFI"
        header-cell-template="title-header"
        cell-template="grid-cell-dropdown"
        edit-cell-template="dropDownBoxEditorMFI"
        
      >
        <DxLookup
          :data-source="dataSource"
          display-expr="MfgCode"
          value-expr="LineNumber"
        />
      </DxColumn>
      <DxColumn
        :min-width="75"
        :width="75"
        :allowEditing="true"
        :allow-sorting="false"
        data-field="PartNumber"
        caption="Part #"
        header-cell-template="title-header"
        cell-template="grid-cell-dropdown"
        edit-cell-template="dropDownBoxEditorPartNumber"
        
      >
        <DxLookup
          :data-source="dataSource"
          display-expr="PartNumber"
          value-expr="LineNumber"
        />
      </DxColumn>
      <DxColumn
        :min-width="100"
        :width="'100%'"
        :allow-sorting="false"
        caption="Description"
        data-field="Description"
        header-cell-template="title-header"
        cell-template="grid-cell-dropdown"
        edit-cell-template="dropDownBoxEditor"
        
      >
        <DxLookup
          :data-source="dataSource"
          display-expr="Description"
          value-expr="LineNumber"
        />
      </DxColumn>
      <DxColumn                       :width="detailView ? 70 : 100" data-field="Retail"            caption="Retail"             header-cell-template="title-header"  cell-template="grid-cell-amount"/>
      <DxColumn :visible="detailView" :width="detailView ? 70 : 100" data-field="DealerCost"        caption="Dealer Cost"        header-cell-template="title-header"  cell-template="grid-cell-amount"/>
      <DxColumn :visible="detailView" :width="detailView ? 70 : 100" data-field="Discount1"         caption="Discount A"           header-cell-template="title-header"  cell-template="grid-cell-percent"/>
      <DxColumn :visible="detailView" :width="detailView ? 70 : 100" data-field="Discount2"         caption="Discount B"           header-cell-template="title-header"  cell-template="grid-cell-percent" />
      <DxColumn :visible="detailView" :width="detailView ? 70 : 100" data-field="DealerExtended"    caption="Dealer Extended"    header-cell-template="title-header"  cell-template="grid-cell-amount" :allowEditing="false"/>
      <DxColumn                       :width="detailView ? 70 : 100" data-field="CustomerCost"      caption="Customer Cost"      header-cell-template="title-header"  cell-template="grid-cell-amount"/>
      <DxColumn                       :width="detailView ? 70 : 100" data-field="CustomerExtended"  caption="Customer Extended"  header-cell-template="title-header"  cell-template="grid-cell-amount" :allowEditing="false"/>
      <DxColumn :visible="detailView" :width="detailView ? 70 : 100" data-field="GPPercent"         caption="GP"                 header-cell-template="title-header"  cell-template="grid-cell-percent"/>
      <DxColumn                       :width="detailView ? 70 : 100" data-field="StockCode"         caption="Stock Code"         header-cell-template="title-header"  cell-template="grid-cell"/>
      <DxColumn
        :visible="false"
        data-field="OrderLineGroupName"
        data-type="string"
      />
      <DxColumn
        :visible="false"
        data-field="OrderLineGroupId"
        data-type="number"
      />
      <DxColumn
        :visible="false"
        data-field="PrintOptionId"
        data-type="number"
      />
      <template #title-header="{ data }">
        <div class="header"  style="fontSize: 16">{{ data.column.caption }}</div>
      </template>
      <template  #grid-cell="{ data }">
          <div :class="dataHasBeenChangedByUser(data) ? 'cell-edited' : 'cell'">{{ data.text }}</div>
      </template>
      <template  #grid-cell-amount="{ data }">
          <div :class="dataHasBeenChangedByUser(data) ? 'cell-edited' : 'cell'">${{ formatCurrency(data.value) }}</div>
      </template>
      <template  #grid-cell-percent="{ data }">
          <div :class="dataHasBeenChangedByUser(data) ? 'cell-edited' : 'cell'">{{ formatPercent(data.value) }}%</div>
      </template>
      <template  #grid-cell-dropdown="{ data }">
          <div :class="dataHasBeenChangedByUser(data) ? 'cell-edited' : 'cell'">{{ data.value }}</div>
      </template>

      <template  #dropDownBoxEditorMFI="{ data : cellInfo}">
        <DescriptionComboboxSearch
          ref="mfg"
          cellEditing="MfgCode"
          :value="cellInfo.value"
          :on-value-changed="cellInfo.setValue"
          @setProductData="setProductData"
          
        />
      </template>
      <template #dropDownBoxEditorPartNumber="{ data : cellInfo}">
        <DescriptionComboboxSearch

          cellEditing="PartNumber"
          :value="cellInfo.value"
          :on-value-changed="cellInfo.setValue"
          @setProductData="setProductData"

        />
      </template>
      <template #dropDownBoxEditor="{ data : cellInfo}">
        <DescriptionComboboxSearch

          cellEditing="Description" 
          :value="cellInfo.value"
          :on-value-changed="cellInfo.setValue"
          @setProductData="setProductData"

        />
      </template>
    <DxSummary :key="summaryUpdateKey" :calculate-custom-summary="calculateSummary">
      <DxTotalItem
        name="SubtotalLabel"
        summary-type="custom"
        display-format="{0}"
        show-in-column="Quantity"
        cssClass="subtotal-header-customer-order-grid"
      />
      <DxTotalItem
        name="retailSummary"
        summary-type="custom"
        display-format="${0}"
        show-in-column="Retail"
        cssClass="summary-text-custom-order-grid"
      />
      <DxTotalItem
        name="DealerCostSummary"
        summary-type="custom"
        display-format="${0}"
        show-in-column="DealerCost"
        cssClass="summary-text-custom-order-grid"
      />
      <DxTotalItem
        name="DealerExtendedSummary"
        summary-type="custom"
        :display-format="'${0}'"
        show-in-column="DealerExtended"
        cssClass="summary-text-custom-order-grid"
      />
      <DxTotalItem
        name="CustomerCostSummary"
        summary-type="custom"
        :display-format="'${0}'"
        show-in-column="CustomerCost"
        cssClass="summary-text-custom-order-grid"
      />
      <DxTotalItem
        name="CustomerExtendedSummary"
        summary-type="custom"
        :display-format="'${0}'"
        show-in-column="CustomerExtended"
        cssClass="summary-text-custom-order-grid"
      />
      <!-- <DxTotalItem
        name="Discount1Summary"
        summary-type="custom"
        :display-format="'{0}%'"
        show-in-column="Discount1"
      />
      <DxTotalItem
        name="Discount2Summary"
        summary-type="custom"
        :display-format="'{0}%'"
        show-in-column="Discount2"
      />
      <DxTotalItem
        name="GPPercentSummary"
        summary-type="custom"
        :display-format="'{0}%'"
        show-in-column="GPPercent"
      /> -->
    </DxSummary>
    </DxDataGrid>
    <dx-tooltip :ref="tooltipRefName" position="top">
      <div class="tooltipContent">
        <div>{{currentCellToolTip}}</div>
      </div>
    </dx-tooltip>
    <Modal ref="deleteBundleModal">
      <div class="card modal-wrapper p-4">
        <p class="m-0">Are you sure you would like</p> 
        <p class="mt-0 ">to delete this bundle?</p>
        <div class="btn-wrapper center row">
            <button class="btn btn-secondary mb-2 col-12" @click="toggleDeleteBundle">Cancel</button>
            <button @click="deleteBundleAndKeepOrderLines" class="btn btn-primary mb-2 col-12">Delete Bundle</button>
            <button @click="deleteBundle" class="btn btn-primary col-12">Delete Bundle and Contents</button>
        </div>
      </div>
    </Modal>
    <Modal  ref="bundleModal">
      <div class="card modal-card">
        <BasicTextInput label="Bundle Title" class="my-1" v-model="newBundleTitle"/>
        <BasicDropdown label="Print Options" class="my-3" :items="printOptionsItems" v-model="newPrintOption"/>
        <button type="button" class="btn btn-primary" @click="createBundle">Create Bundle</button>
      </div>

    </Modal>
    <Modal  ref="editBundleModal">
      <div class="card modal-card">
        <BasicTextInput label="Bundle Title" class="my-1" v-model="newBundleTitle"/>
        <BasicDropdown label="Print Options" class="my-3" :items="printOptionsItems" v-model="newPrintOption"/>
        <button type="button" class="btn btn-primary" @click="editBundle">Update Bundle</button>
      </div>

    </Modal>
    <Modal ref="discountModal">
      <div class="card modal-card">
        <PercentInput label="Discount" class="my-3"  v-model="newDiscount"/>
        <button type="button" class="btn btn-primary" @click="addDiscountToSelectedItems">Add Discount</button>
      </div>
    </Modal>
    <Modal ref="grossProfitModal">
      <div class="card modal-card">
        <PercentInput label="Gross Profit Percent" class="my-3"  v-model="newGrossProfit"/>
        <button type="button" class="btn btn-primary" @click="addGrossProfitToSelectedItems">Add Gross Profit</button>
      </div>
    </Modal>
    <Modal ref="modifyCustomerCostModal">
      <div class="card modal-card">
        <PercentInput label="Customer Cost Modifier" class="my-3"  v-model="modifyCustomerCostPercent"/>
        <button type="button" class="btn btn-primary" @click="addCustomerCostToSelectedItems">Modify Customer Cost</button>
      </div>
    </Modal>
    <Modal ref="modifyDealerCostModal">
      <div class="card modal-card">
        <PercentInput label="Dealer Cost Modifier" class="my-3"  v-model="modifyDealerCostPercent"/>
        <button type="button" class="btn btn-primary" @click="addDealerCostToSelectedItems">Modify Dealer Cost</button>
      </div>
    </Modal>
    <Modal ref="configuratorModal">
      <Configurator @productsAdded="handleConfiguratorAddProductsClicked"/>
    </Modal>
    <Modal ref="smartCatSearchModal">
      <SmartCatalogSearch 
        @productAdded="handleSmartCatalogSearchAddProductClicked" 
        v-on:selected:manufacturer="loadSmartCatalog" 
        v-on:selected:manufacturer:product="loadSmartCatalogProduct"/>
    </Modal>

    <Modal ref="smartCatModal">
      <SmartCatalog
              ref="smartCatWrapper"
              v-on:productClick="handleProductClick"
              :manufacturerId="selectedSmartCatalogManufacturerId"/>
    </Modal>
    <Modal ref="deleteOrderLinesModal">
      <div class="card modal-wrapper p-4">
        <p class="modal-text">Are you sure you would like to delete row(s)?</p>
        <div class="btn-wrapper center">
          <button class="btn btn-secondary" @click="toggleDeleteOrderLinesModal">Cancel</button>
          <button @click="deleteRows" class="btn btn-primary">Delete</button>
        </div>
      </div>
    </Modal>

  </div>
</template>
<script>

import DxDataGrid, {DxSelection,DxRowDragging, DxEditing,  DxColumn, DxButton, DxLookup, DxRequiredRule, DxSummary, DxSorting, DxTotalItem, DxPaging}       from 'devextreme-vue/data-grid';
import DxContextMenu from 'devextreme-vue/context-menu';

import DxTooltip from "devextreme-vue/tooltip"

// import {DescriptionComboboxSearch, SmartCatalogSearch, SmartCatalog, Configurator}           from '../components/index';
import DescriptionComboboxSearch from '../components/DescriptionComboboxSearch.vue';
import Configurator from '../components/Configurator.vue';
import SmartCatalogSearch                   from '../components/SmartCatalogSearch.vue';
import SmartCatalog                         from '../components/SmartCatalog.vue';
import {api, ProductService}                from '@/services';

import { on, off } from "devextreme/events";

import { extractProdData } from "../modules/helpers";
import { OrderService } from '../services';
export default {
  name: 'CustomOrderGrid',
  props: {
    //Array of Objects containing the data used to populate the grid
    //Template: [{city: 'Atlanta', state: 'GA', phone: '(404)854-5859'}]
    dataSource:{
      type: Array,
      default: () => [],
    },
    //Headers used for mapping data to columns columns =[{text: 'Header Label', value: 'Column Value', width: '100px'}], value should match datasource property
    // columns:{
    //   type: Array,
    //   default: () => [],
    // },
    readOnly: {
      type: Boolean,
      default: false
    },
    defaultGP: {
      type: Number,
      default: 0,
    },
    OrderLineGroupName: {
      type: String,
      default: "Individual Line Items"
    },
    OrderLineGroupId: {
      type: Number,
      default: 0,
    },
    printOptions: {
      type: Array,
      default: () => [],
    },
    PrintOptionId: {
      type: Number,
      default: 1,
    },
    showColumnLines:{
      type: Boolean,
      default: false
    },
    showRowLines:{
      type: Boolean,
      default: true
    },
    alternateRowEnabled:{
      type: Boolean,
      default: true
    },
    //Options for ColumnResizing 'nextColumn' and 'widget'
    columnResizingMode: {
      type: String,
      default: 'widget'
    },
    multiSelect:{
      type: Boolean,
      default: true
    },
    cellFontSize: {
      type: String,
      default: '10px'
    },
    headerFontSize: {
      type: String,
      default: '12px'
    },
    gridIndex: {
      type: Number,
      default: 0
    },
    detailView: {
      type: Boolean,
      default: true,
    },
    // products: {
    //   type: Array,
    //   default: () => []
    // },
    roundToDollar: {
      type: Boolean,
      default: false
    },
    totalsSummary: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    DxTooltip,
    DxDataGrid,
    DxRowDragging,
    DxColumn,
    DxSelection,
    DxEditing,
    DxButton,
    DxLookup,
    DxRequiredRule,
    DxSorting,
    DxPaging,
    DxSummary,
    DxTotalItem,
    DxContextMenu,
    DescriptionComboboxSearch,
    SmartCatalogSearch,
    SmartCatalog,
    Configurator
  },
  data() {
    return {
      
      tooltipRefName: 'tooltip',
      filterExpr: null,
      refName: '',
      newDiscount: 0,
      newGrossProfit: 0,
      modifyCustomerCostPercent: 0,
      modifyDealerCostPercent: 0,
      datagridUpdateKey: 0,
      summaryUpdateKey: 0,
      currentGlobalRowEditing: 0,
      currentColumnEditing: 'LineNumber',
      currentColumnEditingIndex: 0,
      newPrintOption: 4, //4 = default for None selection
      emptyProductRow: {
        OrderLineId: null,
        LineNumber: 0, 
        Quantity: 1,
        MfgCode: "",
        MfgId: null,
        PartNumber: "",
        Description: "",
        Retail: 0,
        DealerCost: 0,
        InitialDealerCost: 0,
        Discount1: 0.00,
        Discount2: 0.00,
        ImportedDiscount1: false,
        ImportedDiscount2: false,
        DealerExtended: 0.00,
        CustomerExtended: 0.00,
        CustomerCost: 0.00,
        GPPercent: 0.00,
        StockCode: '',
        OrderLineGroupName: 'Individual Line Items',
        OrderLineGroupId: 0,
        PrintOptionId: 1
      },
      summary: {},
      editing: false,
      newBundleTitle: '',
      dataToCompareChangesAgainst: null, //this will be a copy of the initial data
      selectedItemsDiscount: 1,
      columnAfterComboboxDropdowns: 6,
      currentCellToolTip: '',
      selectedSmartCatalogManufacturerId: null,
      selectedDealerManufacturerId: null,
      selectedSmartCatalogManufacturerCode: null,
      ignoreAlerts: false,
    };
  },
  methods: {
    toggleDeleteBundle(){
      this.$refs['deleteBundleModal'].toggle()
    },
    handleSmartCatalogSearchAddProductClicked(productData){
      let prodData = {...productData}
      prodData.Description = prodData.ProductDescription;
      this.addProductFromSmartCatalogToDataGrid(prodData);
    },
    async handleProductClick(e, MfgId){
      // attempt to get data from link address, if fails, default to info contained in link query params;
      let prodData = await this.getProductData(e, MfgId);
      this.addProductFromSmartCatalogToDataGrid(prodData);
      
    },
    async getProductData(e, MfgId){
      let prodData = extractProdData(e.productHref)
      prodData.MfgId = MfgId
      try {
       return await ProductService.getByCode(prodData);
      } catch {
        prodData.MfgId = this.selectedDealerManufacturerId;
        prodData.MfgCode = this.selectedDealerManufacturerCode;
        return prodData;
      }
    },
    launchConfiguratorModal(){
      this.$refs.configuratorModal.openModal();
    },
    launchSmartCatalogModal(){
      this.$refs.smartCatSearchModal.openModal();
    }, 
    loadSmartCatalog(manufacturerId, dealerMfgId, dealerMfgCode){
      this.selectedSmartCatalogManufacturerId = null;
      this.selectedSmartCatalogManufacturerId = manufacturerId;
      this.selectedDealerManufacturerId = null;
      this.selectedDealerManufacturerId = dealerMfgId;

      this.selectedDealerManufacturerCode = null;
      this.selectedDealerManufacturerCode = dealerMfgCode;
      // this.selectedSmartCatalogManufacturerCode = null;
      // this.selectedSmartCatalogManufacturerCode = manufacturerCode;
      // this.$refs.smartCatSearchModal.closeModal(); 
      this.$refs.smartCatModal.openModal();
    },
    loadSmartCatalogProduct(obj){
      this.selectedSmartCatalogManufacturerId = null;
      this.selectedSmartCatalogManufacturerId = obj.manufacturerId;

      this.selectedDealerManufacturerCode = null;
      this.selectedDealerManufacturerCode = obj.dealerMfgCode;
      this.selectedDealerManufacturerId = null;
      this.selectedDealerManufacturerId = obj.dealerMfgId;
      this.selectedSmartCatalogManufacturerCode = null;
      this.selectedSmartCatalogManufacturerCode = obj.product.MfgCode;
      // this.$refs.smartCatSearchModal.closeModal();
      this.$refs.smartCatModal.openModal();
      this.$nextTick(() => {
        this.$refs.smartCatWrapper.setupPartNumberFilter(obj.product);
      })
    },
    addCustomerCostToSelectedItems(){
      this.currentColumnEditing = 'CustomerCost';
      let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
      this.ignoreAlerts = true;
      rows.forEach(row => {
        let newCustomerCost = row.Retail - (row.Retail * (Math.abs(this.modifyCustomerCostPercent)/100))
        row.CustomerCost = Number(newCustomerCost);
        let setRowToMatchNeededObject = {
          data: row
        }
        this.setCalculatedValues(setRowToMatchNeededObject)
        this.$refs[`${this.refName}`].instance.saveEditData()
        
      })
      this.ignoreAlerts = false;
      this.$refs[`${this.refName}`].instance.clearSelection()
      this.$refs['modifyCustomerCostModal'].toggle();
      this.modifyCustomerCostPercent=0;
      this.datagridUpdateKey++;
    },
    addDealerCostToSelectedItems(){
      this.currentColumnEditing = 'DealerCost';
      let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
      this.ignoreAlerts = true;
      rows.forEach(row => {
        let newDealerCost = row.Retail - (row.Retail * (Math.abs(this.modifyDealerCostPercent)/100))
        row.DealerCost = Number(newDealerCost);
        let setRowToMatchNeededObject = {
          data: row
        }
        this.setCalculatedValues(setRowToMatchNeededObject)
        this.$refs[`${this.refName}`].instance.saveEditData()
        
      })
      this.ignoreAlerts = false;
      this.$refs[`${this.refName}`].instance.clearSelection()
      this.$refs['modifyDealerCostModal'].toggle();
      this.modifyDealerCostPercent=0;
      this.datagridUpdateKey++;
    },
    addGrossProfitToSelectedItems(){
      this.currentColumnEditing = 'GPPercent';
      let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
      this.ignoreAlerts = true;
      rows.forEach(row => {
        row.GPPercent = Number(this.newGrossProfit);
        let setRowToMatchNeededObject = {
          data: row
        }
        this.setCalculatedValues(setRowToMatchNeededObject)
        this.$refs[`${this.refName}`].instance.saveEditData()
        
      })
      this.ignoreAlerts = false;
      this.$refs[`${this.refName}`].instance.clearSelection()
      this.$refs['grossProfitModal'].toggle();
      this.newGrossProfit=0;
      this.datagridUpdateKey++;
    },
    addDiscountToSelectedItems(){
      let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
      rows.forEach(row => {
        if (!row[`Imported${this.selectedItemsDiscount}`]){
          row[`${this.selectedItemsDiscount}`] = Number(this.newDiscount);
          let setRowToMatchNeededObject = {
            data: row
          }
          this.setCalculatedValues(setRowToMatchNeededObject)
          this.$refs[`${this.refName}`].instance.saveEditData()

        
        }
      })
      this.$refs['discountModal'].toggle();
      this.selectedItemsDiscount="";
      this.newDiscount=0;
      this.datagridUpdateKey++;
    },
    addMenuItems(e){
      if (e.target == 'content' && !this.readOnly) {
        // e.items can be undefined
        if (!e.items) e.items = [];
          let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
        // Add a custom menu item
          e.items.push({
            text: 'Add Discount A',
            onItemClick: () => {
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to discount using the checkbox`, type: 'warning' });
                return;
              }
                this.$refs['discountModal'].toggle();
                this.selectedItemsDiscount="Discount1";
            }
          });
          e.items.push({
            text: 'Add Discount B',
            onItemClick: () => {
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to discount using the checkbox`, type: 'warning' });
                return
              }
                this.$refs['discountModal'].toggle();
                this.selectedItemsDiscount="Discount2";
            }
          });
          e.items.push({
            text: 'Modify Gross Profit',
            onItemClick: () => {
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to set GP using the checkbox`, type: 'warning' });
                return
              }
                this.$refs['grossProfitModal'].toggle();
            }
          });
          e.items.push({
            text: 'Modify Customer Cost',
            onItemClick: () => {
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to set customer cost using the checkbox`, type: 'warning' });
                return
              }
                this.$refs['modifyCustomerCostModal'].toggle();
            }
          });
          e.items.push({
            text: 'Modify Dealer Cost',
            onItemClick: () => {
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to set dealer cost using the checkbox`, type: 'warning' });
                return
              }
                this.$refs['modifyDealerCostModal'].toggle();
            }
          });
          e.items.push({
            text: 'Refresh Pricing',
            onItemClick: () => {
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to refresh using the checkbox`, type: 'warning' });
                return
              }
              this.currentColumnEditing = ""
              this.refreshPricing(rows)
            }
          });
          e.items.push({
            text: 'Copy Selected Row(s)',
            onItemClick: () => {
              // let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to copy using the checkbox`, type: 'warning' });
                return
              }
              let numberOfRows = rows.length
              rows = JSON.stringify(rows)
              this.$refs[`${this.refName}`].instance.clearSelection()
              localStorage.setItem('rows', rows);
              this.$store.dispatch('ADD_NOTIFICATION', { text: `${numberOfRows} row(s) copied`, type: 'success' });
            }
          });
          e.items.push({
            text: 'Paste',
            onItemClick: () => {
              let copiedRows = JSON.parse(localStorage.getItem('rows'))
              this.addCopiedRows(copiedRows)
            }
          });
          e.items.push({
            text: 'Delete Selected Row(s)',
            onItemClick: () => {
              if(rows.length <= 0){
                this.$store.dispatch('ADD_NOTIFICATION', { text: `Please select rows you would like to refresh using the checkbox`, type: 'warning' });
                return
              }
              // this.currentColumnEditing = ""
              this.toggleDeleteOrderLinesModal()
              // this.deleteRows();
            }
          });
      }
    },
    toggleDeleteOrderLinesModal(){
      this.$refs.deleteOrderLinesModal.toggle()
    },
    deleteRows(){
      let rows = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
      rows.sort(function(a,b){ return b.LineNumber - a.LineNumber; })
      for (var i = rows.length -1; i >= 0; i--){
        let index = this.dataSource.map(orderLine => orderLine.LineNumber).indexOf(rows[i].LineNumber)
        this.dataSource.splice(index,1);
      }
      this.$refs[`${this.refName}`].instance.clearSelection()
      this.datagridUpdateKey++;
      this.toggleDeleteOrderLinesModal();
      // this.$store.dispatch('ADD_NOTIFICATION', { text: "Selected Orders have been deleted" , type: 'success' });
    },
    refreshPricing(rows){
      OrderService.refreshPricing(rows)
        .then(res => {
          //updatePricing forrows'
          this.ignoreAlerts = true;
          res.forEach(line => {
            console.log('line', line)
            let index = this.dataSource.map(row => row.LineNumber).indexOf(line.LineNumber)
            if(index >= 0){
              line.GPPercent = this.defaultGP;
              if(!line.CustomerCost && this.defaultGP){
                if(line.DealerCost){
                  line.CustomerCost = this.round(-(line.DealerCost/((this.defaultGP / 100) - 1)));
                } else {
                  line.CustomerCost = 0;
                }
              } else if(!line.CustomerCost){
                line.CustomerCost = this.round(line.Retail);
              }
              // line.CustomerCost = !line.CustomerCost || line.Retail
              this.dataSource[index] = line;
              this.setCalculatedValues({data: this.dataSource[index]})
              // this.$refs[`${this.refName}`].instance.saveEditData()
            }
          })
          this.$refs[`${this.refName}`].instance.clearSelection()
          this.datagridUpdateKey++;
        })
        .catch(err => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
        })
        .finally(() => {
          this.ignoreAlerts = false;
        })
    },
    addCopiedRows(rows){
      this.currentGlobalRowEditing = undefined;
      let newLines = [];
      rows.forEach((row, index) => {
        row.OrderLineGroupName = this.OrderLineGroupName;
        row.OrderLineGroupId = this.OrderLineGroupId;
        row.PrintOptionId = this.PrintOptionId;
        row.LineNumber = index;
        newLines.push(this.createObjectForRow(row))
      })
      this.$emit('copyOrderLines', newLines);
      
    },
    copy(obj){
      return JSON.parse(JSON.stringify(obj))
    },
    DealerCostIsGreaterThanRetail(e){
      return e.data.DealerCost > e.data.Retail
    },
    CustomerCostIsGreaterThanRetail(e){
      return e.data.CustomerCost > e.data.Retail
    },
    CustomerCostIsGreaterThanMaximum(e){
      return e.data.MaximumPrice && e.data.CustomerCost > e.data.MaximumPrice
    },
    CustomerCostIsLessThanMinimum(e){
      return e.data.MinimumPrice && e.data.CustomerCost < e.data.MinimumPrice
    },
    setCalculatedValues(e){
      console.log('this.currentColumn eid', this.currentColumnEditing)
      if(this.currentColumnEditing === 'PartNumber' || this.currentColumnEditing === 'MfgCode' || this.currentColumnEditing === 'Description' || this.currentColumnEditing === 'StockCode') return;
      console.log('are we setting calculat3e values')
      if(this.DealerCostIsGreaterThanRetail(e)){
        if(!this.ignoreAlerts) this.$store.dispatch('ADD_NOTIFICATION', { text: 'Dealer Cost cannot be greater than the retail cost', type: 'error' });
        //Add notification alerting user that dealer cost can not be higher than retailcost
        e.data.DealerCost = this.round(e.data.Retail);
        e.data.InitialDealerCost = this.round(e.data.DealerCost);
      } else if(e.data.DealerCost < 0){
        //Add notification alerting user that dealer cost can not be less than 0
        e.data.DealerCost = 0;
        e.data.InitialDealerCost = this.round(e.data.DealerCost);
      }
      
      if(this.currentColumnEditing === 'DealerCost'){ 
        e.data.InitialDealerCost = this.round(e.data.DealerCost);
      };
      let costAfterDiscountA = e.data.InitialDealerCost - ((e.data.Discount1/100) * e.data.InitialDealerCost)
      e.data.DealerCost = this.round(costAfterDiscountA - ((e.data.Discount2/100) * costAfterDiscountA))
      if(this.currentColumnEditing === 'GPPercent') e.data.CustomerCost = this.round(-(e.data.DealerCost/((e.data.GPPercent / 100) - 1)));
      // if(this.currentColumnEditing !== 'CustomerCost') e.data.CustomerCost = this.round(-(e.data.DealerCost/((e.data.GPPercent / 100) - 1)));
      if(this.CustomerCostIsGreaterThanRetail(e)){
        if(!this.ignoreAlerts) this.$store.dispatch('ADD_NOTIFICATION', { text: 'Customer Cost cannot be greater than the retail cost', type: 'error' });
        e.data.CustomerCost = this.round(e.data.Retail);
        e.data.GPPercent = this.roundToTwoDecimals(((e.data.CustomerCost - e.data.DealerCost) / e.data.CustomerCost) * 100);
      } else if(this.CustomerCostIsGreaterThanMaximum(e)){
        if(!this.ignoreAlerts) this.$store.dispatch('ADD_NOTIFICATION', { text: `The Maximum Cost for this product is $${e.data.MaximumPrice}`, type: 'error' });
        e.data.CustomerCost = this.round(e.data.MaximumPrice);
        e.data.GPPercent = this.roundToTwoDecimals(((e.data.CustomerCost - e.data.DealerCost) / e.data.CustomerCost) * 100);
      } else if(this.CustomerCostIsLessThanMinimum(e)){
        if(!this.ignoreAlerts) this.$store.dispatch('ADD_NOTIFICATION', { text: `The Minimum Cost for this product is $${e.data.MinimumPrice}`, type: 'error' });
        e.data.CustomerCost = this.round(e.data.MinimumPrice);
        e.data.GPPercent = this.roundToTwoDecimals(((e.data.CustomerCost - e.data.DealerCost) / e.data.CustomerCost) * 100);
      } else if(e.data.CustomerCost < 0){
        // this.$store.dispatch('ADD_NOTIFICATION', { text: 'Customer Cost cannot be greater than the retail cost', type: 'error' });
        //Add notification alerting user that dealer cost can not be less than 0
        e.data.CustomerCost = 0;
        e.data.GPPercent = 0;
      }
      if(this.currentColumnEditing !== 'GPPercent'){
        if(e.data.CustomerCost === 0){
          e.data.GPPercent = 0;
        } else{
          e.data.GPPercent = this.roundToTwoDecimals(((e.data.CustomerCost - e.data.DealerCost) / e.data.CustomerCost) * 100);
        }
      } 

      e.data.DealerExtended = this.round(e.data.DealerCost * e.data.Quantity);
      e.data.CustomerExtended = this.round(e.data.CustomerCost * e.data.Quantity);
      this.summaryUpdateKey++;
    },
    addProductFromSmartCatalogToDataGrid(productData){
      this.currentGlobalRowEditing = undefined;
      productData.Quantity = 1;
      let orderLine = this.createObjectForRow(productData);
      this.$emit('addProductFromSmartCatalog', orderLine)
      this.datagridUpdateKey++;
      this.$store.dispatch('ADD_NOTIFICATION', { text: `Product: ${productData.PartNumber} was added to your order`, type: 'success' });
      
    },
    handleConfiguratorAddProductsClicked(products){
      this.currentGlobalRowEditing = undefined;
      let newProducts = [];
      products.forEach((product, index) => {
        if(!product.HasMatchingProduct && product.HasMatchingProduct !== undefined ) return;
          
        let data = {
          ...this.emptyProductRow
        }
        if(product.HasMatchingProduct !== undefined){
          data.Retail= product.RetailAmount;
          data.CustomerCost= product.CustomerCost;
          data.DealerCost= product.DealerCost;
          data.Quantity= product.Quantity;
          data.Description= product.Description;
          data.Discount1 = product.Discount1; 
          data.Discount2 = product.Discount2; 
          data.MaximumPrice = product.MaximumPrice;
          data.MinimumPrice = product.MinimumPrice;
          data.MfgCode = product.ManufacturerCode; 
          data.MfgId = product.ManufacturerId; 
          data.StockCode = product.StockCode;
          data.PartNumber = product.PartNumber;
          data.LineNumber = index;
          delete data.lineNumber
        } else {
          data.Quantity = 0;
        }
        let newProduct = this.createObjectForRow(data)
        newProducts.push(newProduct)
      })
      // this.$emit('addProductFromSmartCatalog', products[0])
      this.$emit('addProductsFromConfigurator', newProducts)
      this.datagridUpdateKey++;
      this.$store.dispatch('ADD_NOTIFICATION', { text: `Products were added to your order`, type: 'success' });
    },
    createObjectForRow(data){
      console.log('data', data)
      let newLineNumber;
      let quantity;
      if(this.dataSource[this.currentGlobalRowEditing] === undefined){
        console.log('do we get here')
        let maxLineNumber = 0;
        this.dataSource.forEach(line => {
          console.log('line', line.LineNumber, maxLineNumber)
          if(line.LineNumber >= maxLineNumber){
            maxLineNumber = line.LineNumber+1;
          }
        })
        console.log('max line number', maxLineNumber)
        // newLineNumber = maxLineNumber;
        newLineNumber = data.LineNumber ?  maxLineNumber + data.LineNumber : maxLineNumber;
        quantity = data.Quantity;
      } else{

        newLineNumber = this.dataSource[this.currentGlobalRowEditing].LineNumber;
        console.log('wth', this.dataSource[this.currentGlobalRowEditing])
        quantity = this.dataSource[this.currentGlobalRowEditing].Quantity;
      }

      console.log('line number', newLineNumber)
      if (quantity === null) quantity = 1;
      let newDealerCost = data.DealerCost * ( 1 - (data.Discount1/100) - (data.Discount2/100))
      console.log('customer cost1', data, newDealerCost)
      let newCustomerCost = data.CustomerCost ? data.CustomerCost : Number(data.Retail);
      console.log('customer cost2', newCustomerCost)
      // newCustomerCost = newCustomerCost;
      console.log('customer cost3', newCustomerCost)
      // add  && newCustomerCost if we want customer cost to stay 0.
      newCustomerCost = newDealerCost && !data.CustomerCost ? -(newDealerCost/((this.getGP(newCustomerCost, newDealerCost) / 100) - 1)) : newCustomerCost;
      // let gp = this.getGP(newCustomerCost, newDealerCost)
      let gp = newCustomerCost && newDealerCost ? ((newCustomerCost - newDealerCost) / newCustomerCost) * 100 : 0;
      console.log('gp', gp, newCustomerCost, newDealerCost)
      //in the below if statements we reset the gp not using the getGP function because we want to avoid the default gp condition
      if(newCustomerCost > Number(data.Retail)){
        newCustomerCost = Number(data.Retail)
        gp = newCustomerCost ? ((newCustomerCost - newDealerCost) / newCustomerCost) * 100 : 0;
      } else if(data.MaximumPrice && newCustomerCost > Number(data.MaximumPrice)){
        newCustomerCost = Number(data.MaximumPrice)
        gp = newCustomerCost ? ((newCustomerCost - newDealerCost) / newCustomerCost) * 100 : 0;
      } else if(data.MinimumPrice && newCustomerCost < Number(data.MinimumPrice)){
        newCustomerCost = Number(data.MinimumPrice)
        gp = newCustomerCost ? ((newCustomerCost - newDealerCost) / newCustomerCost) * 100 : 0;
      }
      console.log('customer cost4', newCustomerCost, gp, newDealerCost)
      let orderLine = {
        ...this.emptyProductRow,
        LineNumber: newLineNumber,
        Description: data.Description,
        Discount1: data.Discount1 || 0,
        Discount2: data.Discount2 || 0,
        ImportedDiscount1: data.Discount1 ? true : false,
        ImportedDiscount2: data.Discount2 ? true : false,
        PartNumber: data.PartNumber,
        MaximumPrice: data.MaximumPrice,
        MinimumPrice: data.MinimumPrice,
        MfgId: data.MfgId,
        MfgCode: data.MfgCode,
        InitialDealerCost: this.round(data.DealerCost) || 0,
        DealerCost: this.round(newDealerCost) || 0,
        CustomerCost: this.round(newCustomerCost),
        DealerExtended: this.round(newDealerCost * quantity),
        CustomerExtended: this.round(newCustomerCost * quantity),
        GPPercent: this.roundToTwoDecimals(gp),
        StockCode: data.StockCode,
        Retail: this.round(data.Retail) || 0,
        Quantity: quantity,
        OrderLineGroupName: this.OrderLineGroupName,
        OrderLineGroupId: this.OrderLineGroupId,
        PrintOptionId: this.PrintOptionId,
      }
      return orderLine;
    },
    getGP(customerCost, dealerCost){
      return this.defaultGP ?
      this.defaultGP :
      customerCost === 0 || customerCost === null ? 0 : ((customerCost - dealerCost) / customerCost) * 100  ;
    },
    setProductData(data, e){
      if(!this.addingNewRow()){
        this.dataSource[this.currentGlobalRowEditing] = this.createObjectForRow(data)
        this.dataToCompareChangesAgainst[this.currentGlobalRowEditing] = this.copy(this.dataSource[this.currentGlobalRowEditing])
        var grid = this.$refs[`${this.refName}`].instance;  
        // grid.saveEditData();
        grid.focus(grid.getCellElement(this.localRow, this.columnAfterComboboxDropdowns));
        grid.editCell(this.localRow, this.columnAfterComboboxDropdowns);
        this.currentColumnEditingIndex = this.columnAfterComboboxDropdowns;

      }
    },
    addingNewRow(){      
      return this.currentGlobalRowEditing >= this.dataSource.length
    },
    dataHasBeenChangedByUser(data){
      let row = this.dataToCompareChangesAgainst[data.rowIndex]

      // return data.value !== row[data.column.dataField]
      return false // the above statement is what I will want.. but for now I am disabling this feature
    },
    onEditingStart(e){
      this.currentGlobalRowEditing = this.dataSource.map(item => item.LineNumber).indexOf(e.data.LineNumber)
      this.currentColumnEditing = e.column.dataField
      this.currentColumnEditingIndex = e.column.index
    },
    calculateSummary(options) {
      //should probably make this a switch
      if (options.name === 'SubtotalLabel') {
        options.totalValue = 'Subtotal:';
        
      }
      else if (options.name === 'retailSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.Quantity && options.value.Retail){
            options.totalValue = options.totalValue + (options.value.Retail * options.value.Quantity);
          }
        } else if (options.summaryProcess === 'finalize') {
          this.summary.retail = this.round(options.totalValue);
          options.totalValue = this.formatCurrency(options.totalValue);
        }
      }
      else if (options.name === 'DealerCostSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.DealerCost){
            options.totalValue = options.totalValue + options.value.DealerCost;
          }
        } else if (options.summaryProcess === 'finalize') {
          options.totalValue = this.formatCurrency(options.totalValue);
        }
      }
      else if (options.name === 'DealerExtendedSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.DealerExtended){
            options.totalValue = options.totalValue + options.value.DealerExtended;
          }
        } else if (options.summaryProcess === 'finalize') {
          this.summary.dealerCost = this.round(options.totalValue);
          options.totalValue = this.formatCurrency(options.totalValue);
        }
      }
      else if (options.name === 'CustomerCostSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.CustomerCost){
            options.totalValue = options.totalValue + options.value.CustomerCost;
          }
        } else if (options.summaryProcess === 'finalize') {
          options.totalValue = this.formatCurrency(options.totalValue);
        }
      }
      else if (options.name === 'CustomerExtendedSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.CustomerExtended){
            options.totalValue = options.totalValue + options.value.CustomerExtended;
          }
        } else if (options.summaryProcess === 'finalize') {
          this.summary.subtotal = this.round(options.totalValue);
          options.totalValue = this.formatCurrency(options.totalValue);
        }
        
      }
      else if (options.name === 'Discount1Summary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
          options.totalCount = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.Discount1){
            options.totalValue = options.totalValue + options.value.Discount1;
            options.totalCount ++;
          }
        } else if (options.summaryProcess === 'finalize') {
          options.totalValue = this.formatPercent(options.totalValue/options.totalCount);
        }
      }
      else if (options.name === 'Discount2Summary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
          options.totalCount = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.Discount2){
            options.totalValue = options.totalValue + options.value.Discount2;
            options.totalCount ++;
          }
        } else if (options.summaryProcess === 'finalize') {
          options.totalValue = this.formatPercent(options.totalValue/options.totalCount);
        }
      }
      else if (options.name === 'GPPercentSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
          options.totalCount = 0;
        } else if (options.summaryProcess === 'calculate') {
          if(options.value.GPPercent){
            options.totalValue = options.totalValue + options.value.GPPercent;
            options.totalCount ++;
          }
        } else if (options.summaryProcess === 'finalize') {
          options.totalValue = this.formatPercent(options.totalValue/options.totalCount);
        }
      }
    },

    roundToTwoDecimals(data){
      if(Number(data) === 'NaN') return;
      return Number(Number(data).toFixed(2));
    },
    round(data){
      if(Number(data) === 'NaN') {
        return;
      };

      return this.roundToDollar ? Math.round(Number(data)) : this.roundToTwoDecimals(Number(data));
    },
    deleteBundle(){
      this.$emit('deleteBundle', this.OrderLineGroupId )
    },
    deleteBundleAndKeepOrderLines(){
      this.$emit('deleteBundleAndKeepOrderLines', this.OrderLineGroupId )
    }, 
    clearNewBundleData(){
      this.newBundleTitle="";
      this.newPrintOption=1;
    },
    toggleEditBundleModal(){
      this.clearNewBundleData();
      this.$refs.editBundleModal.toggle()
    },
    openEditBundleModal(){
      this.newPrintOption = this.PrintOptionId;
      this.newBundleTitle = this.OrderLineGroupName;
      this.$refs.editBundleModal.toggle()
    },
    toggleCreateBundleModal(){
      this.clearNewBundleData();
      this.$refs.bundleModal.toggle()
    },
    editBundle(){
      let bundle = {
        OrderLineGroupName: this.newBundleTitle,
        PrintOptionId: this.newPrintOption,
        OrderLineGroupId: this.OrderLineGroupId,
      }
      this.$emit('editBundle', bundle);
      this.toggleEditBundleModal();
    },
    createBundle(){
      let data = this.$refs[`${this.refName}`].instance.getSelectedRowsData()
      data.forEach(item => {
        item.OrderLineGroupName = this.newBundleTitle;
        item.OrderLineGroupId = -1;
        item.PrintOptionId = this.newPrintOption
      })
      this.$emit('createNewBundle', this.newBundleTitle, this.newPrintOption)
      this.toggleCreateBundleModal()
    },
    formatCurrency(currency){
      if(typeof(currency) !== 'number') return;
      if(currency === 0 || currency === null) return ''
      return this.roundToDollar ? Math.round(currency).toFixed(2) : currency.toFixed(2)
    },
    formatPercent(percent){
      if(typeof(percent) !== 'number') return;
      if(percent  === 0 || percent === null) return ''
      return percent.toFixed(2)
    },
    onReorder(e) {
      var visibleRows = e.component.getVisibleRows(),
        toIndex = this.dataSource.indexOf(visibleRows[e.toIndex].data),
        fromIndex = this.dataSource.indexOf(e.itemData);
      this.dataSource.splice(fromIndex, 1);
      this.dataSource.splice(toIndex, 0, e.itemData);
      this.$emit('updateOrderLineNumbers')
    },
    onAdd(e) {
      e.itemData.OrderLineGroupId = e.toData;
      let lineNumber = e.itemData.LineNumber
      let bundleId = e.toData
      this.$emit('updateData', lineNumber, bundleId);
    }, 
    onEditorPreparing(e){ 
      if(e.row && e.row.isNewRow){
        this.$refs[`${this.refName}`].instance.saveEditData();
      }

      if(e.dataField === 'Discount1'){
        e.editorOptions.disabled = e.parentType === "dataRow" && e.row.data.ImportedDiscount1;
      }
      if(e.dataField === 'Discount2'){
        e.editorOptions.disabled = e.parentType === "dataRow" && e.row.data.ImportedDiscount2;
      }   
      if(e.dataField === 'DealerCost'){
        e.editorOptions.disabled = e.parentType === "dataRow" && (e.row.data.ImportedDiscount1 || e.row.data.ImportedDiscount2);
      }
    },
    addNewRow() {
        this.$refs[`${this.refName}`].instance.addRow();
        this.$emit('itemHasBeenAdded')
    },
    initNewRow(e){
      let newLineNumber = 0;
      this.dataSource.forEach(item => {
        if(item.LineNumber >= newLineNumber) newLineNumber = item.LineNumber + 1;
      })
      e.data = {
        ...this.emptyProductRow,
        OrderLineGroupName: this.OrderLineGroupName,
        OrderLineGroupId: this.OrderLineGroupId,
        PrintOptionId: this.PrintOptionId,
        LineNumber: newLineNumber
      } 
      this.dataToCompareChangesAgainst.push(e.data)
    },
    onCellPrepared(e) {
      if (e.rowType === "header" && e.column.caption) {
        var self = this;
        on(e.cellElement, "mouseover", arg => {
            self.currentCellToolTip = e.column.caption;
            self.$refs[self.tooltipRefName].instance.show(arg.target);
        });
        on(e.cellElement, "mouseout", arg => {
          self.$refs[self.tooltipRefName].instance.hide();
        });
      }
    }
    
  },
  watch: {
    summary: {
      deep: true,
      handler(){
        this.$emit('updateTotalsValues', this.summary, this.OrderLineGroupId)
      }
    },
  },
  computed: {
    localRow(){
      let row = 0;
      let finalRow = 0;
      this.dataSource.forEach(obj => {
        if(obj.OrderLineGroupId === this.OrderLineGroupId){
          row++;
          if(obj.LineNumber === this.currentGlobalRowEditing){
            finalRow = row;
          }
        }
      })
      return finalRow - 1;
    },
    printOptionsItems() {
      let options = []
      this.printOptions.forEach(option => {
        options.push({
          text: option.DisplayName,
          value: option.Id
        })
      })
      return options;
    }
  },
  created(){
    this.refName = 'customOrderGrid' + this.OrderLineGroupId;
    this.filterExpr = ['OrderLineGroupId', '=', this.OrderLineGroupId]
    this.dataToCompareChangesAgainst = this.copy(this.dataSource)
    this.loading = true
    this.summary = this.totalsSummary
  }
};
</script>
<style lang="scss" scoped>
  .order-grid-wrapper{
    max-width: 100%;
    width: 100%;
    min-width: 100%;
  }
  .header {
    color: $primary;
    font-size: 16px;
  }
  td{
    padding: 0px !important;
  }
  .cell {
    font-size: 13px;
    color: $ss_grey1;
    padding: 0px;
    &-edited{
      padding: 0px;
      color: $primary;
    }
  }
  
  .modal-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    width: 400px;
    height: 100%;
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
  .tooltipContent div {
    text-align: left;
  }
  .modal-wrapper{
        width: 400px;
        display: flex;
        font-size: 1.2em;
        justify-content: space-around;
        align-items: center;
        .modal-text{
          text-align: center;
          margin-top: 10px;
          margin-bottom: 0px;
        }
        .btn-wrapper{
            margin-top: 25px;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            .btn{
              min-height: 100%;
              min-width: 125px;
            }
            &.center{
                justify-content: space-around;
                align-items: center;
            }
        }
    }
</style>
